<!-- <body class="description-long">{{question === '' ? '?' : question}}</body> -->
<div *ngIf="show">
  <div *ngIf="index != 0" class="top-line"></div>
  <h2 class="title">{{question}}</h2>
  <vc-poll-results-result
    *ngFor="let result of results"
    [result]="result">
  </vc-poll-results-result>
</div>
